import { TAccount } from './accounts.types';

/**
 * Gets the offer that was funded in an account
 * @param account: TAccount- An Account object
 * @returns The offer object
 */
export const getAccountFundedFormalOffer = (
    account: TAccount
): TAccount['formal_offers'][number] | undefined => {
    if (!account.loan_offer_id) return undefined;
    if (account.formal_offers.length === 0) return undefined;
    return account.formal_offers.find(
        (offer) => offer.offer_id === account.loan_offer_id
    );
};
